import { render, staticRenderFns } from "./WH_HandoverPendencyReport.vue?vue&type=template&id=67f171e8"
import script from "./WH_HandoverPendencyReport.vue?vue&type=script&lang=js"
export * from "./WH_HandoverPendencyReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports